import { RoleType } from '@vtblife/event-bus-events/dist';

export const agreementAvailableRoleType = [RoleType.Makler, RoleType.Realtor, RoleType.Professional];
